import classNames from 'classnames';
import React from 'react';

import * as styles from './Toggle.module.scss';

interface ToggleProps {
  label?: string;
  children: React.ReactNode;
}

const Toggle: React.FC<ToggleProps> = ({ children, label }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const toggleVisibility = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsVisible(!isVisible);
  };

  return (
    <section
      className={classNames(styles.disclosureSection, {
        [styles.expanded]: isVisible,
      })}
    >
      <p className={styles.subhead}>
        <button className={styles.disclosuresLink} onClick={toggleVisibility}>
          {label || 'Important product information'}
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8">
            <path d="M4.152 1.357a1 1 0 0 1 1.7 0l3.2 5.113A1 1 0 0 1 8.2 8H1.8a1 1 0 0 1-.844-1.53Z" />
          </svg>
        </button>
      </p>
      {isVisible && children}
    </section>
  );
};

export default Toggle;
